"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1933],{

/***/ 41933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


function BuilderLink(param) {
    var url = param.url, children = param.children, target = param.target;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: url,
        target: target,
        children: children !== null && children !== void 0 ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            children: "Add a child element to this block"
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (BuilderLink);


/***/ })

}]);